/**
 * @ngdoc Controller
 * @name ProfileController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('ProfileController', ProfileController);

    /**
     * @constructor
     * @ngInject
     */
    function ProfileController($log, $scope, UserService) {
        $log.info('ProfileController');

        if (!$scope.user) {
            UserService.getUser().then(function(user) {
                $scope.user = user;
            });
        }

        $scope.reloadUser = function() {
            // Reload user
            UserService.loading = UserService.reload().then(function(user) {
                $scope.user = user;
            });
        }
    }

})();
